import {
    GET_Q_SISE_ITEMSPOLICY_REJECTED,
    GET_Q_SISE_ITEMSPOLICY_PENDING,
    GET_Q_SISE_ITEMSPOLICY,
    GET_Q_SISE_ITEMSPOLICY_FULFILLED
} from '../actions/types';

const initialState = {
    data: {},
    loading: false,
    error: false
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_Q_SISE_ITEMSPOLICY_PENDING:
            return {
                ...state,
                loading: true,
                error: false
            };
        case GET_Q_SISE_ITEMSPOLICY_FULFILLED:
            return {
                ...state,
                data: { ...state.data, ...action.payload },
                loading: false,
                error: false
            };
        case GET_Q_SISE_ITEMSPOLICY_REJECTED:
            return {
                ...state,
                data: [],
                loading: false,
                error: true
            };
        case GET_Q_SISE_ITEMSPOLICY:
            return {
                ...state,
                selected: action.payload
            };
        default:
            return state;
    }
}
